








































import {
  defineComponent,
  PropType,
  getCurrentInstance
} from "@vue/composition-api";
import OccHeading from "@/components/Atoms/OccHeading/index.vue";
import { occBlack } from "@/assets/styles/vars-for-script.scss";
import { sendGaEvent } from "@/helpers/ga-helper";

export default defineComponent({
  name: "guideBar",
  components: {
    OccHeading
  },
  props: {
    message: {
      type: String,
      required: false
    },
    links: {
      type: Array as PropType<{ text: string; href: string }[]>,
      required: false
    }
  },
  setup() {
    const instance = getCurrentInstance();
    const handleClick = (gaEventCategory: string) => {
      if (instance) {
        sendGaEvent(instance.proxy, {
          gaEventCategory: `ガイド_${gaEventCategory}`
        });
      }
    };
    return { occBlack, handleClick };
  }
});
